<span [ngClass]="{ 'start-step-button-wrapper' : isStartStep }">
  <button
    mat-flat-button class="primary non-mobile-continue-button"
    [disabled]="disableContinueButton"
    (click)="continueBtnClickEvent()"
    [attr.aria-label]="ariaLabelBeginning + ' Go to step ' + nextStepNumber + ' of ' + totalSteps">{{ isStartStep ? startButtonText : continueButtonText}}</button>

  <button *ngIf="isStartStep"
    mat-flat-button class="primary mobile-start-button"
    (click)="mobileStartBtnClickEvent()"
    [attr.aria-label]="ariaLabelBeginning + ' Open new tab and go to step ' + nextStepNumber + ' of ' + totalSteps">{{ startButtonText}}</button>
</span>

